import { render, staticRenderFns } from "./CompanyUsageReport.vue?vue&type=template&id=a06e0562&scoped=true"
import script from "./CompanyUsageReport.vue?vue&type=script&lang=ts"
export * from "./CompanyUsageReport.vue?vue&type=script&lang=ts"
import style0 from "./CompanyUsageReport.vue?vue&type=style&index=0&id=a06e0562&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06e0562",
  null
  
)

export default component.exports